import { render, staticRenderFns } from "./GoodsClasses.vue?vue&type=template&id=acde0a26&scoped=true&"
import script from "./GoodsClasses.vue?vue&type=script&lang=js&"
export * from "./GoodsClasses.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClasses.vue?vue&type=style&index=0&id=acde0a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acde0a26",
  null
  
)

export default component.exports